
/**
 * getUrlParameters
 * Constrói um objeto que pode ser traduzido em parametros no formato de urls get (ex: param1=a&param2=b)
 * @param {any} params - Objeto de qualquer tipo com as propriedades que irão constar na url
 */
export default function getUrlParameters(params: any)
{
    //Params pode ser de qualquer tipo, com propriedades de qualquer nome.
    //Abaixo, para cadas propriedade params, incluir no objeto final. Se essa propriedade for um array, um foreach inclui cada item do array repetidamente, para ficar no formato certo:
    //prop=valor&propArray=valor1&propArray=valor2
    //PS: favor ler o código deste método com a música da Pantera Cor-de-rosa na cabeça.
    const urlParams = new URLSearchParams();
    for(let param in params)
    {
        if (Array.isArray(params[param]))
            params[param].forEach((item:any) => urlParams.append(param, item.toString()));
        else if (params[param] !== undefined && params[param] !== null)
            urlParams.append(param, params[param]);
    }

    return urlParams;
}